var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7a1 1 0 011-1h10a1 1 0 110 2H7a1 1 0 01-1-1zM7 11a1 1 0 100 2h6a1 1 0 100-2H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2a1 1 0 011-1h22a1 1 0 011 1v15a1 1 0 01-1 1h-6.52l-3.7 4.625a1 1 0 01-1.56 0L7.52 18H1a1 1 0 01-1-1V2zm2 1v13h6a1 1 0 01.78.375L12 20.4l3.22-4.024A1 1 0 0116 16h6V3H2z"
  })));
}
export default SvgChatOutline;